<div fxShow="true" fxShow.gt-sm="false">
    <div class="header-title">{{title}}</div>
</div>